import { fetch } from '@/plugin/axios/index.js'
import formAxios from '@/plugin/axios/formAxios.js'


/**
 * 合同回款列表
 * @param {Object} data 
 */
export function getPageList(data) {
  return fetch({
    url: '/financial/collection/employee/list',
    method: 'POST',
    data
  })
}


/**
 * 合同回款导出
 * @param {Object} data 
 */
export function exportContractCollection(data) {
  return formAxios({
    url: '/financial/collection/employee/export',
    method: 'POST',
    data
  })
}


/**
 * 合同回款删除
 * @param {Object} data 
 */
export function removeEmployeeCollection(data) {
  return fetch({
    url: '/financial/collection/employee/remove',
    method: 'POST',
    data
  })
}


/**
 * 合同回款列表
 * @param {Object} data 
 */
export function realList(data) {
  return fetch({
    url: '/financial/collection/contract/real/list',
    method: 'POST',
    data
  })
}


/**
 * 创建合同回款
 * @param {Object} data 
 */
export function createContractCollection(data) {
  return fetch({
    url: '/financial/collection/contract/create',
    method: 'POST',
    data
  })
}


/**
 * 删除合同回款
 * @param {Object} data 
 */
export function deleteContractCollection(data) {
  return fetch({
    url: '/financial/collection/real/remove',
    method: 'POST',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/ContractReceivables/index.js